(function() {
    'use strict';
    //this file must be at the end of the entire bundle
    $(function() { // using jQuery because it will run this even if DOM load already happened
        angular.bootstrap(document.documentElement, ['TR']);
    });
})();
